import React, { useEffect, useState } from 'react'
import { PriceComponent } from './price'
import { imgUrlConverter, hostUrlConverter } from '../../util'
import { PdfComponent } from "./pdfComponent";


export const ProductDetailInfo = React.memo(({ appData: { servicedata }, appData: { pagecontextdata } }) => {
  const [showDesc, setShowDesc] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [showMetalOpt, setShowMetalOpt] = useState(false);
  const [showMetalSection, setShowMetalSection] = useState(true);

  useEffect(()=>{
    let prodcutDetailInfo = pagecontextdata?.find((content)=> content.contentType === "productDetails")
    setShowMetalSection(!prodcutDetailInfo?.hideMetalOption)
  },[pagecontextdata])

  return (<>
    <div className="price-section">
      <PriceComponent data={servicedata?.productData} /> 
      {/* <span className="ml-3"><i className="fa fa-info-circle" aria-hidden="true" /> <span className="text-underline">view my options</span></span>  */}
    </div>
    <div className="mobile-ctaBtn">
      <a href={hostUrlConverter(servicedata?.productData?.addToCartUrl)}>
        <button type="button" className="product-cta-button">{servicedata?.productData?.configurableFlag ? "CUSTOMIZE" : "ADD TO CART"}</button>
      </a>
    </div>
    <hr />

    <div className="product-detail-card">
      <div className={`card-title ${showDesc ?"card-title-expanded":""}`} onClick={()=>setShowDesc(!showDesc)}><b>Product Description</b> <i className={`accordianArrow ${showDesc ?"arrowUp":"arrowDown"}`}/></div>
      <div className={`card-desc ${showDesc ?"":"prod-desc"}`} dangerouslySetInnerHTML={{ __html: servicedata?.productData?.description }}></div>
    </div>
    <hr />
    <div className="product-detail-card">
      <div className={`card-title ${showInfo ?"card-title-expanded":""}`} onClick={()=>setShowInfo(!showInfo)}><b>Shipping Information</b> <i className={`accordianArrow ${showInfo ?"arrowUp":"arrowDown"}`}/> </div>
      <div className={`card-desc ${showInfo ?"":"card-info"}`}>{servicedata?.productData?.shippingMsg}</div>
    </div>
    <hr />
    <div className="product-detail-card">
      {showMetalSection && servicedata?.productData?.metalOptions?.metals?.length > 0 &&
        <>
          <div className={`card-title ${showMetalOpt ?"card-title-expanded":""}`} onClick={()=>setShowMetalOpt(!showMetalOpt)}><b>Metal Options</b> <i className={`accordianArrow ${showMetalOpt ?"arrowUp":"arrowDown"}`}/> </div>
          <div className={`card-desc ${showMetalOpt ?"":"card-metal"}`}>
            {servicedata?.productData?.metalOptions?.description}
            <div className="mb-3 metal-options-grid">
              {
                servicedata?.productData?.metalOptions?.metals?.length > 0 &&
                servicedata?.productData?.metalOptions?.metals.map((metalImg, key) =>
                  <div>
                    <img className="p-1" height={60} width={60} key={key} src={imgUrlConverter(metalImg?.imageUrl)} alt={metalImg?.metalName+"."} />
                    <div className="fontSizeXS metal-options-name" title={metalImg?.metalName+"."}>{`${metalImg?.metalName}`}</div>
                  </div>
                )
              }
            </div>
          </div>
          <hr />
        </>
      }
      <a href={hostUrlConverter(servicedata?.productData?.addToCartUrl)}>
        <button type="button" className="product-overlay-button mr-5">{servicedata?.productData?.configurableFlag ? "CUSTOMIZE" : "ADD TO CART"}</button>
      </a>
      
      {/* <div>
        <button type="button" className="product-overlay-button mr-5">START NOW</button>
        <i className="far fa-heart" /> <span className="text-underline">Save to wishlist</span>
      </div> */}
      {<PdfComponent content={pagecontextdata?.find((content)=> content.contentType === "ringSizerContent")}/>}
    </div>
  </>)
})
